import { baseFetch } from 'src/utils';

export const newsletterSubscribeAPI = async (email: string): Promise<void> => {
  const res = await baseFetch('/api/contact/newsletter/register', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    throw new Error();
  }
};
